'use strict';

var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var reactCropper_es = require('../../node_modules/react-cropper/dist/react-cropper.es.js');
var blobUtil_es = require('../../node_modules/blob-util/dist/blob-util.es.js');
var Dialog = require('../../DesignSystem/Feedback/Dialog/Dialog.js');
var DialogActions = require('../../DesignSystem/Feedback/Dialog/DialogActions.js');
var DialogContent = require('../../DesignSystem/Feedback/Dialog/DialogContent.js');
var DialogTitle = require('../../DesignSystem/Feedback/Dialog/DialogTitle.js');
var Button = require('../../DesignSystem/Inputs/Buttons/Button/Button.js');
var IconButton = require('../../DesignSystem/Inputs/Buttons/IconButton.js');
var makeStyles = require('../../DesignSystem/Styles/makeStyles.js');
var RotateLeft = require('../../IconsAndImages/Icons/RotateLeft.js');
var RotateRight = require('../../IconsAndImages/Icons/RotateRight.js');
var ZoomIn = require('../../IconsAndImages/Icons/ZoomIn.js');
var ZoomOut = require('../../IconsAndImages/Icons/ZoomOut.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  var minHeightBreakpoint = "@media (min-height: 660px)";
  return {
    dialogContent: defineProperty({
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 0
    }, minHeightBreakpoint, {
      paddingTop: theme.spacing(1)
    }),
    cropper: {
      height: 400,
      width: '100%'
    },
    zoomButtons: defineProperty({
      order: -1
    }, minHeightBreakpoint, {
      order: 0,
      marginTop: theme.spacing(1)
    }),
    actionButtons: defineProperty({
      paddingTop: theme.spacing(1)
    }, minHeightBreakpoint, {
      paddingTop: 0
    })
  };
});

var CropImageDialog = function CropImageDialog(_ref) {
  var open = _ref.open,
      _ref$dialogTitle = _ref.dialogTitle,
      dialogTitle = _ref$dialogTitle === void 0 ? 'Crop your image' : _ref$dialogTitle,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$saveButtonDisabl = _ref.saveButtonDisabled,
      saveButtonDisabled = _ref$saveButtonDisabl === void 0 ? false : _ref$saveButtonDisabl,
      _ref$saveButtonText = _ref.saveButtonText,
      saveButtonText = _ref$saveButtonText === void 0 ? 'Save' : _ref$saveButtonText,
      _ref$cancelButtonDisa = _ref.cancelButtonDisabled,
      cancelButtonDisabled = _ref$cancelButtonDisa === void 0 ? false : _ref$cancelButtonDisa,
      _ref$cancelButtonText = _ref.cancelButtonText,
      cancelButtonText = _ref$cancelButtonText === void 0 ? 'Cancel' : _ref$cancelButtonText,
      onSaveCroppedImage = _ref.onSaveCroppedImage,
      onClose = _ref.onClose,
      imageUrl = _ref.imageUrl,
      _ref$initialAspectRat = _ref.initialAspectRatio,
      initialAspectRatio = _ref$initialAspectRat === void 0 ? 1 : _ref$initialAspectRat,
      aspectRatio = _ref.aspectRatio,
      _ref$minCropBoxHeight = _ref.minCropBoxHeight,
      minCropBoxHeight = _ref$minCropBoxHeight === void 0 ? 10 : _ref$minCropBoxHeight,
      _ref$minCropBoxWidth = _ref.minCropBoxWidth,
      minCropBoxWidth = _ref$minCropBoxWidth === void 0 ? 10 : _ref$minCropBoxWidth,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? false : _ref$background,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      _ref$autoCropArea = _ref.autoCropArea,
      autoCropArea = _ref$autoCropArea === void 0 ? 1 : _ref$autoCropArea,
      _ref$checkOrientation = _ref.checkOrientation,
      checkOrientation = _ref$checkOrientation === void 0 ? false : _ref$checkOrientation,
      _ref$guides = _ref.guides,
      guides = _ref$guides === void 0 ? false : _ref$guides,
      restProps = objectWithoutProperties(_ref, ["open", "dialogTitle", "isLoading", "saveButtonDisabled", "saveButtonText", "cancelButtonDisabled", "cancelButtonText", "onSaveCroppedImage", "onClose", "imageUrl", "initialAspectRatio", "aspectRatio", "minCropBoxHeight", "minCropBoxWidth", "background", "responsive", "autoCropArea", "checkOrientation", "guides"]);

  var classes = useStyles();
  var cropperRef = React.useRef(null);

  var handleSave = function handleSave() {
    var _cropperRef$current;

    var canvas = (_cropperRef$current = cropperRef.current) === null || _cropperRef$current === void 0 ? void 0 : _cropperRef$current.cropper.getCroppedCanvas({
      imageSmoothingQuality: 'high'
    });
    blobUtil_es.imgSrcToBlob(canvas.toDataURL()).then(function (blob) {
      var _cropperRef$current2;

      return onSaveCroppedImage(blob, (_cropperRef$current2 = cropperRef.current) === null || _cropperRef$current2 === void 0 ? void 0 : _cropperRef$current2.cropper);
    });
  };

  var zoomIn = function zoomIn() {
    var _cropperRef$current3;

    (_cropperRef$current3 = cropperRef.current) === null || _cropperRef$current3 === void 0 ? void 0 : _cropperRef$current3.cropper.zoom(0.1);
  };

  var zoomOut = function zoomOut() {
    var _cropperRef$current4;

    (_cropperRef$current4 = cropperRef.current) === null || _cropperRef$current4 === void 0 ? void 0 : _cropperRef$current4.cropper.zoom(-0.1);
  };

  var rotateLeft = function rotateLeft() {
    var _cropperRef$current5;

    (_cropperRef$current5 = cropperRef.current) === null || _cropperRef$current5 === void 0 ? void 0 : _cropperRef$current5.cropper.rotate(-90);
  };

  var rotateRight = function rotateRight() {
    var _cropperRef$current6;

    (_cropperRef$current6 = cropperRef.current) === null || _cropperRef$current6 === void 0 ? void 0 : _cropperRef$current6.cropper.rotate(90);
  };

  return React__default["default"].createElement(Dialog, {
    open: open
  }, React__default["default"].createElement(DialogTitle, null, dialogTitle), React__default["default"].createElement(DialogContent, {
    className: classes.dialogContent
  }, React__default["default"].createElement(reactCropper_es.Cropper, _objectSpread({
    ref: cropperRef,
    className: classes.cropper,
    src: imageUrl,
    initialAspectRatio: initialAspectRatio,
    aspectRatio: aspectRatio,
    minCropBoxHeight: minCropBoxHeight,
    minCropBoxWidth: minCropBoxWidth,
    background: background,
    responsive: responsive,
    autoCropArea: autoCropArea,
    checkOrientation: checkOrientation,
    guides: guides
  }, restProps)), React__default["default"].createElement("div", {
    className: classes.zoomButtons
  }, React__default["default"].createElement(IconButton, {
    onClick: zoomOut
  }, React__default["default"].createElement(ZoomOut, null)), React__default["default"].createElement(IconButton, {
    onClick: zoomIn
  }, React__default["default"].createElement(ZoomIn, null)), React__default["default"].createElement(IconButton, {
    onClick: rotateRight
  }, React__default["default"].createElement(RotateRight, null)), React__default["default"].createElement(IconButton, {
    onClick: rotateLeft
  }, React__default["default"].createElement(RotateLeft, null)))), React__default["default"].createElement(DialogActions, {
    className: classes.actionButtons
  }, React__default["default"].createElement(Button["default"], {
    color: "secondary",
    onClick: onClose,
    disabled: cancelButtonDisabled
  }, cancelButtonText), React__default["default"].createElement(Button["default"], {
    color: "primary",
    onClick: handleSave,
    disabled: saveButtonDisabled,
    loading: isLoading
  }, saveButtonText)));
};

module.exports = CropImageDialog;
